<div class="lm-columnar-adhoc-report-measures-flyout">
  <div class="lm-columnar-measures-title">
    <h4 class="lm-bold lm-header-4" data-automation-id="lm-columnar-adhoc-report-measures-header">{{measuresHeader}}</h4>
  </div>
  <div class="lm-columnar-adhoc-report-measures scrollable-y"
      cdkDropList
      [id] = "MEASURES_LIST"
      [cdkDropListConnectedTo] = "MEASURES_LIST"
      [cdkDropListData]="MEASURES_LIST"
      [cdkDropListEnterPredicate]="canDrop"
      (cdkDropListDropped)="drop($event)"
  >
    @for (m of measures; track m; let i = $index) {
      <div class="lm-adhoc-facade-field" cdkDrag [cdkDragData]="m">
        <div *cdkDragPreview class="lm-columnar-adhoc-report-measures">
          <svg cdkDragHandle soho-icon class="lm-icon" [icon]="'drag'" soho-tooltip [content]="'Drag Me'"/>
          <div><p>{{m.label.resourceValue }}</p></div>
        </div>
        <svg cdkDragHandle soho-icon class="lm-icon" [icon]="'drag'" soho-tooltip [content]="'Drag Me'"  [attr.data-automation-id]="'lm-measure-' + i + '-drag-icon'"/>
        <p [attr.data-automation-id]="'lm-measure-' + i + '-txt'">{{ m.label.resourceValue }}</p>
        <button type="button"><svg soho-icon icon="delete" (click)="removeMeasure(i)"></svg></button>
      </div>
    }
  </div>
  <div class="lm-columnar-measures-title">
    <h4 class="lm-bold lm-header-4" data-automation-id="lm-columnar-adhoc-report-available-measures-header">{{availableMeasuresHeader}}</h4>
  </div>
  <div class="lm-columnar-adhoc-report-available-measures scrollable-y">
    @for (field of availableMeasures; track field; let i = $index) {
      <div class="lm-adhoc-facade-field">
        <p [attr.data-automation-id]="'lm-available-measure-' + i + '-txt'">{{ field.name }}</p>
        <button type="button"><svg soho-icon icon="add" (click)="addMeasure(i)"></svg></button>
      </div>
    }
  </div>
</div>
